import { getAuthAxiosBackend } from "../helpers/axios"

class LocationServices{

    getAll(){
        return getAuthAxiosBackend().get('locations')
    }
}

export default new LocationServices()